module.exports = __webpack_public_path__ + "static/media/aam-education.3564d0c1.jpg";